import { render, staticRenderFns } from "./ModalCommentRoot.vue?vue&type=template&id=8b035cfa&"
import script from "./ModalCommentRoot.vue?vue&type=script&lang=ts&"
export * from "./ModalCommentRoot.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports